import {
  dealerService
}
from '../services';

import PrepareFilter from '../utils/PrepareFilter';
import config from '../Config';

const state = {
  status: {},
  dealer: [],
  address: null,
  distance: 100,
  filter: 0,
  country: 'DE',
  searchstring: null,
  showOffers: true,
  vehiclesCount: -1,
  bookmarks: [],
  topic: 0,
  allTopics: [{
    id: 0,
    name: 'Allgemein'
  }, {
    id: 1,
    name: 'Vermietung'
  }, {
    id: 2,
    name: 'Verkauf'
  }, {
    id: 3,
    name: 'Service'
  }],
  topics: [],
  distanceOptions: [10, 20, 50, 100, 200, 500],
  locationVehicleListScrollPosition: 0,
  dealerVehicleListScrollPosition: 0,
  countrys: [{
    name: "Deutschland",
    value: "DE"
  }, {
    name: "Frankreich",
    value: "FR"
  }, {
    name: "Italien",
    value: "IT"
  }, {
    name: "Kanada",
    value: "CA"
  }, {
    name: "Luxemburg",
    value: "LU"
  }, {
    name: "Niederlande",
    value: "NL"
  }, {
    name: "Schweiz",
    value: "CH"
  }, {
    name: "Vereinigte Staaten",
    value: "US"
  }, {
    name: "Vereinigtes Königreich",
    value: "UK"
  }, {
    name: "Österreich",
    value: "AT"
  }]
};

const actions = {

  async dealerByLocation(state, opt) {

      await dealerService.getDealerByLocation(opt.lat, opt.lng, opt.limit,
          opt.filter)
        .then(
          data => {
            if (!data) {
              this.commit('availableVehiclesCountFailure');
            } else {
              this.commit('summery/dealerByLocationSuccess', data);
            }
          },
          error => {
            this.dispatch('summery/error', error, {
              root: true
            });
          }
        );

      return true
    },
    async recordContactEmail(state, request) {

      return dealerService.recordContactEmail(request.email,
        request.lang);

    },
    async confirmContactEmail(state, requestid) {


      return dealerService.confirmContactEmail(requestid);

    },
    async confirmRequest(state, requestid) {

      return dealerService.confirmRequest(requestid);

    },
    async error(state, error) {
      console.log("Error");

    }
};

function mapImages(i) {
  return Promise.all(i.map((image) => {
    return {
      src: config.filedelivery + image,
      org: image
    };
  }));
}
const mutations = {
  async dealerByLocationSuccess(state, dealer) {
      state.dealer = dealer;
    },
    address(state, address) {
      state.address = address
    },
    filter(state, filter) {
      state.filter = filter
    },
    topic(state, topic) {
      state.topic = topic
    },
    topics(state, topics) {
      state.topics = topics
    },
    alltopics(state, topics) {
      state.allTopics = topics
    },
    availableVehiclesCountFailure(state) {
      state.vehiclesCount = -1;
    }
};

const getters = {}

export const summery = {
  namespaced: true,
  state,
  actions,
  mutations
};
